import Loadable from 'react-loadable';

const Loading = () => null;  //加载时不现实loading

// 引入组件

// 打印执照
const Printlicense = Loadable({ 
  loader: () => import('@/pages/Printlicense/Printlicense'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// 打印执照
const Printenterprise = Loadable({ 
  loader: () => import('@/pages/Printenterprise/Printenterprise'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// 执照照亮
const Lightlicense = Loadable({ 
	loader: () => import('@/pages/Lightlicense/Lightlicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
  });

// 验证执照
const Checklicense = Loadable({ 
  loader: () => import('@/pages/Checklicense/Checklicense'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// 验证结果
const Checkresult = Loadable({ 
	loader: () => import('../pages/Checkresult/Checkresult'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 使用指南
const Userguide = Loadable({ 
  loader: () => import('@/pages/userguide/Userguide'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// 常见问题修改
const Problem = Loadable({ 
  loader: () => import('@/pages/problem/Problem'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// 投资任职（新增功能）
const Information = Loadable({ 
  loader: () => import('@/pages/information/Information'), //按需加载 点击时只加载一个页面
  loading: Loading,
});

// ---------------二级路由----------------
// 下载执照
const Downloadlicense = Loadable({ 
	loader: () => import('@/pages/userguide/Downloadlicense/Downloadlicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 出示执照
const Showlicense = Loadable({ 
	loader: () => import('@/pages/userguide/Showlicense/Showlicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 查看执照
const Looklicense = Loadable({ 
	loader: () => import('@/pages/userguide/Looklicense/Looklicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 扫一扫
const Scan = Loadable({ 
	loader: () => import('@/pages/userguide/Scan/Scan'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 管理执照
const Managelicense = Loadable({ 
	loader: () => import('@/pages/userguide/Managelicense/Managelicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 授权他人管理执照
const Othersmanagelicense = Loadable({ 
	loader: () => import('@/pages/userguide/Othersmanagelicense/Othersmanagelicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 授权他人使用执照
const Othersuselicense = Loadable({ 
	loader: () => import('@/pages/userguide/Othersuselicense/Othersuselicense'), //按需加载 点击时只加载一个页面
	loading: Loading,
});

// 授权他人使用执照
const Batch = Loadable({ 
	loader: () => import('@/pages/Batch/Batch'), //按需加载 点击时只加载一个页面
	loading: Loading,
});


// 通过组件配置路由
const routes = [
	{
		path: '/printlicense',
		component: Printlicense
	},
	{
		path: '/Printenterprise',
		component: Printenterprise
	},
	{
		path: '/lightlicense',
		component: Lightlicense
	},
	{
		path: '/checklicense',
	 	component: Checklicense
	},
	{
		path: '/checkresult',
	 	component: Checkresult
	},
	{
		path: '/userguide',
		component: Userguide,
		children: [{
			path: '/userguide/downloadlicense',
			component: Downloadlicense
		},{
			path: '/userguide/showlicense',
			component: Showlicense
		},{
			path: '/userguide/looklicense',
			component: Looklicense
		},{
			path: '/userguide/scan',
			component: Scan
		},{
			path: '/userguide/managelicense',
			component: Managelicense
		},{
			path: '/userguide/othersmanagelicense',
			component: Othersmanagelicense
		},{
			path: '/userguide/othersuselicense',
			component: Othersuselicense
		}] 
	},
	{
		path: '/problem', //常见问题
	 	component: Problem
	},
	{
		path: '/information', // 投资任职
	 	component: Information
	},
	{
		path: '/batch', //常见问题
	 	component: Batch
	},
];

export default routes